export default __webpack_public_path__ + "static/media/grafema_clivitalbio_19.8bb75869.jpg";